import { render, staticRenderFns } from "./ManageWorker.vue?vue&type=template&id=3bb486bc&"
import script from "./ManageWorker.vue?vue&type=script&lang=ts&"
export * from "./ManageWorker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports